export default "__VITE_ASSET__Bl74bH4H__"